import React, { FC, useState } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Dialog, DialogProps } from '@modernloop/shared/components';
import { TextField } from '@mui/material';

type EditNoteModalProps = Pick<DialogProps, 'open' | 'onClose'> & {
  note: string;
  onSubmit: (newNote: string) => void;
};

const EditNoteModal: FC<EditNoteModalProps> = ({ note, onClose, onSubmit, open }) => {
  const { t } = useTranslation();
  const [noteValue, setNoteValue] = useState<string>(note.trim());

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t('hiring-dashboard-common:common.notes.editComment')}
      cancelOptions={{ label: t('hiring-dashboard-common:common.cancel'), onClick: (e) => onClose?.(e) }}
      submitOptions={{
        onClick: () => {
          onSubmit(noteValue);
        },
        label: t('hiring-dashboard-common:common.save'),
        isDisabled: noteValue === note,
      }}
    >
      <TextField
        autoFocus
        multiline
        minRows={3}
        fullWidth
        defaultValue={noteValue}
        onChange={(e) => {
          setNoteValue(e.target.value.trim());
        }}
        sx={{ minHeight: 'unset', whiteSpace: 'pre-line' }}
      />
    </Dialog>
  );
};

export default EditNoteModal;
